import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UIAPIEndpoints {
    static socketServerWSS() {
        return UIUtilsEjsVariables.ejsSocketServerWss;
    }
    static googleAuth(callbackHash) {
        if (callbackHash) return `auth/google?callbackHash=${callbackHash}`;
        return '/auth/google';
    }
    static appleAuth(callbackHash) {
        if (callbackHash) return `/auth/apple?callbackHash=${callbackHash}`;
        return '/auth/apple';
    }
    static discordAuth(callbackHash) {
        if (callbackHash) return `/auth/discord?callbackHash=${callbackHash}`;
        return '/auth/discord';
    }
    static discordActivityAuth() {
        return '/auth/discord-activity';
    }
    static googleLink(callbackHash) {
        if (callbackHash) return `/auth-link/google?callbackHash=${callbackHash}`;
        return '/auth-link/google';
    }
    static appleLink(callbackHash) {
        if (callbackHash) return `/auth-link/apple?callbackHash=${callbackHash}`;
        return '/auth-link/apple';
    }
    static discordLink(callbackHash) {
        if (callbackHash) return `/auth-link/discord?callbackHash=${callbackHash}`;
        return '/auth-link/discord';
    }
    static googleUnlink() {
        return '/auth-unlink/google';
    }
    static appleUnlink() {
        return '/auth-unlink/apple';
    }
    static discordUnlink() {
        return '/auth-unlink/discord';
    }
    static logout() {
        return '/logout';
    }
    static checkoutProductUrl(productType) {
        return `/checkout?product=${productType}`;
    }
    static checkoutMembershipUrl(membershipType) {
        return `/checkout?membership=${membershipType}`;
    }
    static checkoutOneTimePurchaseUrl(oneTimePurchaseType) {
        return `/checkout?one-time-purchase=${oneTimePurchaseType}`;
    }
    static apiPayGetStoreStripeSession() {
        return '/api/pay/get-store-stripe-session';
    }
    static apiPayGetStripePaymentClientSecret() {
        return '/api/pay/get-stripe-payment-client-secret';
    }
    static apiPayGetStoreXsollaSession() {
        return '/api/pay/get-store-xsolla-session';
    }
    static apiPayCreateCustomerPortalSession() {
        return '/api/pay/stripe-create-customer-portal-session';
    }
    static apiPayPurchaseItem() {
        return '/api/pay/purchase-item';
    }
    static apiActivateGiftMembership() {
        return '/api/membership/activate-gift';
    }
    static apiCancelGiftMembership() {
        return '/api/membership/cancel-gift';
    }
    static apiAnalytics() {
        return '/api/analytic-events';
    }
    static apiUpdateProfile() {
        return '/api/profile-edit';
    }
    static apiDeleteProfile() {
        return '/api/profile/delete';
    }
    static apiFindGameState() {
        return '/api/find-game-ranked-state';
    }
    static apiUserState() {
        return '/api/user-state';
    }
    static apiUserStateCreate() {
        return '/api/user-state/create';
    }
    static apiUserLoginState() {
        return '/api/user-login-state';
    }
    static apiUserProfileAddFriend() {
        return '/api/profile-edit/add-friend-request';
    }
    static apiUserProfileAcceptFriend() {
        return '/api/profile-edit/accept-friend-request';
    }
    static apiUserProfileRemoveFriend() {
        return '/api/profile-edit/remove-friend';
    }
    static apiUserProfileRankedSeasons() {
        return '/api/profile/ranked-seasons';
    }
    static apiGetDiscordAccessToken() {
        return '/api/discord/token';
    }
    static apiHandleDiscordPurchase() {
        return '/api/discord/handle-purchase';
    }
    static apiSaveDiscordData() {
        return '/api/discord/save-data';
    }
    static apiFriendRequestsReceived() {
        return `/api/header/friend-requests-received`;
    }
    static apiSetUserLanguage() {
        return `/api/user/language`;
    }
    static apiSetUserReferrer() {
        return `/api/user/set-referrer`;
    }
    static apiGetUserReferralCount() {
        return `/api/user/get-referral-count`;
    }
    static apiAssignABTest() {
        return `/api/user/assign-ab-test`;
    }
    static apiGetRoomList() {
        return `/api/room-list.json`;
    }
    static apiGetGameList() {
        return `/api/game-list.json`;
    }
    static apiGetRegions() {
        return `/api/regions.json`;
    }
    static apiReportPlayer(username) {
        return `/api/${encodeURIComponent(username)}/report-user`;
    }
    static apiFeedbackFormSubmit() {
        return `/api/feedback-form`;
    }
    static apiFeedbackFormShow() {
        return `/api/show-feedback-form`;
    }
    static apiGetNotifications() {
        return `/api/notifications`;
    }
    static apiMarkNotificationAsRead(notificationId) {
        return `/api/notifications/${notificationId}/mark-as-read`;
    }
    static apiValidateUsername(username) {
        return `/api/validate-username/${username}`;
    }
    static apiUsernameChangeInfo() {
        return '/api/profile-edit/username-change-info';
    }
    static apiEditProfileInfo() {
        return '/api/profile-edit/info';
    }
    static apiChangeRegion() {
        return `/api/profile/change-region`;
    }
    static apiReplayShareableLink(gameId, playerColor) {
        return `/api/replay/shareable-link?gameId=${gameId}&playerColor=${playerColor}`;
    }
    static apiReplayDataFromSlug(replayUrlSlug) {
        return `/api/replay/data-from-slug?replayUrlSlug=${replayUrlSlug}`;
    }
    static apiReplayDataFromGameId(gameId, playerColor) {
        return `/api/replay/data-from-game-id?gameId=${gameId}&playerColor=${playerColor}`;
    }
    static apiRedeemGiftFromHash() {
        return `/api/gift-membership/redeem`;
    }
    static apiGetGiftMembershipData(hash) {
        return `/api/gift-membership/hash?hash=${hash}`;
    }
    static apiSaveGiftMetadata() {
        return '/api/gift-membership/metadata';
    }
    static apiReactivationMessage() {
        return '/api/plan-user-reactivation';
    }
    static apiChampionship25Content() {
        return '/api/championship25/content';
    }
    static apiChampionship26Content() {
        return '/api/championship26/content';
    }
    static apiFreePlayDiceRoll() {
        return '/api/free-play-dice-roll';
    }
    static apiHelplyToken() {
        return '/api/helply-token';
    }
    static apiNoltToken() {
        return '/api/nolt-token';
    }
}
UIAPIEndpoints.apiUserProfile = Object.freeze({
    stickyPlayerInfo: (username)=>`/api/profile/${encodeURIComponent(username)}/sticky-player-info`,
    overview: (username)=>`/api/profile/${encodeURIComponent(username)}/overview`,
    history: (username)=>`/api/profile/${encodeURIComponent(username)}/history`,
    items: (username)=>`/api/profile/${encodeURIComponent(username)}/items`,
    friends: ()=>`/api/profile/friends`,
    ranked: (username)=>`/api/profile/${encodeURIComponent(username)}/ranked`,
    username: (userId)=>`/api/profile/${userId}/username`
});
UIAPIEndpoints.apiLeaderboards = Object.freeze({
    data: (rankedModeType, leaderboardUrl)=>`/api/leaderboards/${rankedModeType}/${leaderboardUrl}`,
    usernameSearch: (rankedModeType, leaderboardUrl)=>`/api/leaderboards-username-search/${rankedModeType}/${leaderboardUrl}`,
    tabs: (leaderboardUrl)=>`/api/leaderboards-tabs/${leaderboardUrl}`,
    stickyRowData: (rankedModeType, leaderboardUrl)=>`/api/leaderboards-my-sticky-row-data/${rankedModeType}/${leaderboardUrl}`
});
